import React from 'react';
import LearnBreadcrumb from '../../components/LearnBreadcrumb';

const biomes = [
  {
    name: 'Desert',
    img: require('../../img/card_symbols/biome_symbols/desert.png'),
    description: [
      "Desert biomes are defined by their extreme aridity, receiving very little precipitation. Despite harsh conditions, deserts host specialized plant and animal life adapted to conserve water and withstand extreme temperature fluctuations. These adaptations include nocturnal activity, efficient water storage, and deep root systems.",
      "Deserts can be hot, like the Sahara, or cold, like the Gobi, but all share the common trait of low moisture. Organisms in these environments have evolved unique strategies to survive, such as cacti storing water, and animals burrowing underground during the day. Deserts play a role in global atmospheric circulation and can contain unique geological formations."
    ]
  },
  {
    name: 'Forest',
    img: require('../../img/card_symbols/biome_symbols/forest.png'),
    description: [
      "Forest biomes are characterized by dense tree cover and are among the most biodiverse and productive ecosystems on Earth. They play a critical role in regulating climate, producing oxygen, and housing countless species. Different types of forests exist, including tropical rainforests, temperate forests, and boreal forests, each with distinct climates and biodiversity.",
      "Tropical rainforests, found near the equator, are known for their high rainfall and constant warm temperatures, supporting an unparalleled variety of plant and animal life. Temperate forests experience distinct seasons, with trees often shedding leaves in autumn. Boreal forests (taiga) are found in cold northern regions, dominated by coniferous trees adapted to long, cold winters."
    ]
  },
  {
    name: 'Freshwater',
    img: require('../../img/card_symbols/biome_symbols/freshwater.png'),
    description: [
      "Freshwater biomes include lakes, rivers, ponds, and wetlands, characterized by low salt concentration. These vital ecosystems support from fish and amphibians to aquatic plants and insects.",
      "Lakes and ponds are standing bodies of water, varying in size and depth, with distinct zones of light penetration and temperature. Rivers and streams are flowing water systems, often originating in mountains and flowing towards oceans, shaping landscapes and transporting nutrients. Wetlands, such as marshes and swamps, are transitional areas between terrestrial and aquatic environments."
    ]
  },
  {
    name: 'Grassland',
    img: require('../../img/card_symbols/biome_symbols/grassland.png'),
    description: [
      "Grassland biomes are dominated by grasses and herbaceous plants, with few trees or shrubs. They are found on every continent except Antarctica and are characterized by moderate rainfall, seasonal droughts, and grazing animals. Grasslands support large populations of herbivores and their predators.",
      "Savannas are tropical grasslands with scattered trees, experiencing distinct wet and dry seasons. Temperate grasslands, like prairies and steppes, have hot summers and cold winters. Both types of grasslands are shaped by fire and grazing, which prevent tree growth and maintain the dominance of grasses."
    ]
  },
  {
    name: 'Marine',
    img: require('../../img/card_symbols/biome_symbols/marine.png'),
    description: [
      "Marine biomes encompass saltwater environments, primarily the world's oceans, coral reefs, and estuaries. These vast biomes cover over 70% of Earth's surface and are critical for global climate regulation, nutrient cycling, and supporting an immense diversity of life, from microscopic plankton to the largest whales.",
      "Oceans are characterized by varying depths, temperatures, and light levels, creating diverse habitats like the sunlit euphotic zone and the dark abyssal zone."
    ]
  },
  {
    name: 'Tundra',
    img: require('../../img/card_symbols/biome_symbols/tundra.png'),
    description: [
      "Tundra biomes are the coldest of all biomes, characterized by permafrost (permanently frozen subsoil), low-growing vegetation, and a short growing season. They are found in the polar regions and on high mountain tops (alpine tundra). Despite the harsh conditions, tundra supports unique and resilient life forms.",
      ""
    ]
  },
];

function Biomes() {
  return (
    <div className="container py-4">
      <LearnBreadcrumb />
      <h1 className="display-4 mb-4 text-center">Biomes</h1>
      <p className="lead text-center mb-5">Discover the distinct biomes represented in the game and their unique characteristics.</p>

      {biomes.map((biome) => (
        <div key={biome.name} className="mb-5">
          <div className="row align-items-start">
            <div className="col-12 col-md-3 mb-3 mb-md-0 d-flex justify-content-center">
              <div style={{ maxWidth: '200px', textAlign: 'center' }}>
                <img
                  src={biome.img}
                  alt={biome.name}
                  className="img-fluid"
                  style={{ maxHeight: '200px', objectFit: 'contain' }}
                />
                <h3 className="mt-3">{biome.name}</h3>
              </div>
            </div>
            <div className="col-12 col-md-9">
              {biome.description.map((paragraph, idx) => (
                <p key={idx} className="mb-3">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
          <hr className="my-4" />
        </div>
      ))}
    </div>
  );
}
export default Biomes;